import AppPage from '@/components/app-page/index.vue';

export default [
  {
    path: '/service-analysis',
    name: 'ServiceAnalysis',
    component: AppPage,
    meta: {
      title: '服务分析',
      style: 'cpu',
    },
    children: [
      {
        path: 'errorReport',
        name: 'AnalyzeErrorReport',
        component: () => import('@/views/analyze/error-report/index.vue'),
        meta: {
          title: '错误异常',
          style: 'sunny',
          activeMenu: '/analyze/healthy',
          isNotMenu: true,
          isUseServerInfo: true,
          isDisabledServerInfo: false,
          isDisabledAppInfo: false,
        },
      },
      {
        path: 'errorReportDetail',
        name: 'AnalyzeErrorReportDetail',
        component: () => import('@/views/analyze/error-report/detail.vue'),
        meta: {
          title: '错误异常',
          style: 'house',
          activeMenu: '/analyze/users',
          isUseEnvInfo: true,
          isNotMenu: true,
        },
      },
      // 首页
      {
        path: 'api-analysis',
        name: 'AnalyzeInterface',
        component: () => import('@/views/service-analysis/api-analysis/index.vue'),
        meta: {
          title: '服务概况',
          style: 'coffee-cup',
          isUseServerInfo: true,
        },
      },
      // 二期接口概况
      {
        path: 'api-situation',
        name: 'SituationInterface',
        component: () => import('@/views/service-analysis/api-situation/index.vue'),
        meta: {
          title: '接口概况',
          style: 'connection',
          isUseServerInfo: true,
        },
      },
      // 错误概况
      {
        path: 'error-analysis',
        name: 'AnalyzeInterfaceError',
        component: () => import('@/views/service-analysis/error-analysis/index.vue'),
        meta: {
          title: '错误概况',
          isUseEnvInfo: true,
          isUseServerInfo: true,
          style: 'bell',
        },
      },
      // 接口请求列表
      {
        path: 'api-query',
        name: 'AnalyzeInterfaceList',
        component: () => import('@/views/service-analysis/api-query/index.vue'),
        meta: {
          title: '接口查询',
          // activeMenu: '/tracking/slowSystemCall',
          isUseServerInfo: true,
          isUseEnvInfo: true,
          style: 'chat-square',
        },
      },
      {
        path: 'errorReportDetail',
        name: 'ServiceAnalysisErrorReportDetail',
        component: () => import('@/views/log/error-report/detail.vue'),
        meta: {
          title: '错误异常',
          style: 'sunny',
          activeMenu: '/log/errorReport',
          isNotMenu: true,
          isUseAppInfo: true,
          isDisabledServerInfo: true,
          isDisabledAppInfo: true,
        },
      },
      {
        path: 'relation',
        name: 'AnalyzeRelation',
        component: () => import('@/views/service-analysis/relation/index.vue'),
        meta: {
          title: '拓扑图',
          style: 'data-line',
          activeMenu: '/analyze/relation',
          isUseServerInfo: true,
          isUseWholeServer: true, // 是否使用所有服务
        },
      },
      {
        path: 'api-service-statistics',
        name: 'ServiceStatistics',
        component: () => import('@/views/service-analysis/api-service-statistics/index.vue'),
        meta: {
          title: '服务接口统计 ',
          style: 'data-line',
          activeMenu: '/analyze/api-service-statistics',
        },
      },
      {
        path: 'api-service-dependent',
        name: 'ServiceDependent',
        component: () => import('@/views/service-analysis/api-service-dependent/index.vue'),
        meta: {
          title: '服务依赖统计',
          style: 'data-line',
          activeMenu: '/analyze/api-service-dependent',
        },
      },
    ],
  },
];
